import React from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import SuppliersFlight from "../components/suppliers-flight";
import LowCostAirlines from "../assets/resources/Low-Cost-Airlines-Integrated-by-TravelCarma.pdf";

const ApiFlightIntegration = () => {
  return (
    <div>
      <PageHeader page="flight-api-integration" />
      <div className="container">
        <div className="text-center">
          <p>
            85+ suppliers integrated—we manage integration complexity for you. Enterprise integration options: managed service (we handle it), custom connectors (built to your spec), or API-first architecture (extend without replacement). Deep relationships with GDS, LCCs, and consolidators mean ongoing support, not just one-time integration.
          </p>

          <SuppliersFlight />
        </div>
      </div>
    </div>
  );
};

export default ApiFlightIntegration;
